import React, { useState, useEffect, useRef } from "react";
import Table from "./Table";
import AuthUser from "../../../Loji/loji";

const Dashboard = () => {
  const [totalApplications, setTotalApplications] = useState(0);
  const [maleApplications, setMaleApplications] = useState(0);
  const [femaleApplications, setFemaleApplications] = useState(0);

  const { http } = AuthUser();
  const SEEF_DASHBOARD = "counts";

  // Use refs to store the previous count values
  const prevTotalRef = useRef(0);
  const prevMaleRef = useRef(0);
  const prevFemaleRef = useRef(0);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response = await http.get(SEEF_DASHBOARD);
        if (response.status !== 200) {
          throw new Error("Failed to fetch counts");
        }
        const data = response.data;


        // Animate and set new counts
        animateCount(prevTotalRef.current, data.totalApplications, setTotalApplications, (val) => {
          prevTotalRef.current = val;
        });
        animateCount(prevMaleRef.current, data.maleApplications, setMaleApplications, (val) => {
          prevMaleRef.current = val;
        });
        animateCount(prevFemaleRef.current, data.femaleApplications, setFemaleApplications, (val) => {
          prevFemaleRef.current = val;
        });
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    // Fetch immediately
    fetchCounts();

    // Then refetch every 90 seconds
    const interval = setInterval(fetchCounts, 90000);
    return () => clearInterval(interval);
  }, []);

  const animateCount = (start, end, setter, updateRef) => {
    const duration = 800; // ms
    const steps = Math.ceil(duration / 16);
    const increment = (end - start) / steps;
    let current = start;
    let count = 0;

    const step = () => {
      current += increment;
      count++;

      if (count >= steps) {
        setter(end);
        updateRef(end);
      } else {
        setter(Math.round(current));
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  return (
    <div className="h-screen p-4 py-8 md:py-12 sm:py-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div className="bg-blue-500 text-white p-4 h-32 rounded shadow-md">
          <h3 className="text-lg font-semibold">Total Application Submitted</h3>
          <p className="text-2xl">{totalApplications}</p>
        </div>
        <div className="bg-green-500 text-white p-4 h-32 rounded shadow-md">
          <h3 className="text-lg font-semibold">Male</h3>
          <p className="text-2xl">{maleApplications}</p>
        </div>
        <div className="bg-pink-500 text-white p-4 h-32 rounded shadow-md">
          <h3 className="text-lg font-semibold">Female</h3>
          <p className="text-2xl">{femaleApplications}</p>
        </div>
      </div>

      <div>
        <Table />
      </div>
    </div>
  );
};

export default Dashboard;
